import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import CertificateModel from "../../UI/CertificateModel";
import styles from "./SidebarInfo.module.css";
import { FaCertificate } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Certificates = ({ PatientData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [certificateData, setCertificateData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchAllCertificateData = async () => {
    const token = getAuthToken();
    if (token === null || token === "EXPIRED") {
      navigate("/");
      return;
    }

    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/certificate/getAllCertificateNames`;

    try {
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Could not fetch details");
      }

      const data = await response.json();
      setCertificateData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching certificate data:", error);
    }
  };

  const onCertificateDataCloseHandler = () => {
    navigate(".");
    setCertificateData([]);
    setShowModal(false);
  }
  return (
    <>
      <div className={styles.sidebarCard}>
        <div className={styles.sidebarContent}>
          <button className={styles.premiumButton} onClick={fetchAllCertificateData}>
            <FaCertificate /> {t("Get Certificate")}
          </button>
        </div>
      </div>

      {showModal && (
        <CertificateModel
          certificateData={certificateData}
          OnCloseModalBlock={onCertificateDataCloseHandler}
          PatientData={PatientData}
        />
      )}
    </>
  );
};

export default Certificates;
